<template>
  <b-alert
    v-model="show"
    :dismissible="dismissible"
    :variant="variant">
    {{ msg }}
  </b-alert>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import bus from '@/plugins/bus'

@Component
export default class Alert extends Vue {
  msg: string = ''
  show: boolean = false
  variant: string = 'info'
  dismissible: boolean = false

  mounted (): void {
    bus.on('showAlert', this.alert)
  }

  alert (options = { msg: '', show: true, variant: 'info', dismissible: false }): void {
    this.msg = options.msg
    this.show = options.show
    this.variant = options.variant
    this.dismissible = options.dismissible

    setTimeout(() => {
      this.show = false
      this.msg = ''
      this.variant = undefined
      this.dismissible = false
    }, 4000)
  }
}
</script>

<style scoped lang="scss">
.alert {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
}
</style>
